import Default from '@pages/home'

export default {
  path: '',
  name: 'home',
  components: {
    default: Default,
  },
}